module.exports = __webpack_public_path__ + "static/media/workday.8079fa90.png";